import { render, staticRenderFns } from "./r-currency-deprecate-dialog.vue?vue&type=template&id=e37b1bfc&scoped=true"
import script from "./r-currency-deprecate-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-deprecate-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-currency-deprecate-dialog.vue?vue&type=style&index=0&id=e37b1bfc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37b1bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e37b1bfc')) {
      api.createRecord('e37b1bfc', component.options)
    } else {
      api.reload('e37b1bfc', component.options)
    }
    module.hot.accept("./r-currency-deprecate-dialog.vue?vue&type=template&id=e37b1bfc&scoped=true", function () {
      api.rerender('e37b1bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-deprecate-dialog.vue"
export default component.exports